import { useSelector } from 'react-redux';
import { SectionAlert, Txt } from '@vst/beam';
import { Router } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { selectingPendingInstallation } from '@app/redux/pendingInstallation';

import styles from './Alert.module.scss';

export const EquipmentShippingAlert = () => {
  const { t } = useTranslation('Profile');

  const { newOfferName } = useSelector(selectingPendingInstallation);

  return (
    <SectionAlert variant="infoPrimary" icon={Router}>
      <div className={styles['alert-content']}>
        <Txt data-cy="text" component="span" variant="smallRegular" color="regular">
          {t('equipmentShipmentAlert', {
            planName: newOfferName,
          })}
        </Txt>
      </div>
    </SectionAlert>
  );
};
